__turbopack_context__.v({
  "moneyPostLayoutWrapper": "EdgePortfolioTemplate-module__KS0AwG__moneyPostLayoutWrapper",
  "wrapper": "EdgePortfolioTemplate-module__KS0AwG__wrapper",
});
